import logoImage from '../../../../assets/images/logos/previsoraBlack.png';
export const GuidoBanner = () => {
    return (
        <div className="banner-container">
            <div className="banner-card">
                <div className="image-container">
                    <img
                        src={logoImage}
                        alt="Previsora logo"
                        className="guido-image"
                    />
                </div>
            </div>
        </div>
    );
};
